import React from 'react';
import './DetailedBio.css';

const DetailedBio = () => {
  return (
    <div className="detailed-bio">
      <div className='detailed-bio-wrapper'>
        <h2>Our Development Focus</h2>
        <p>Guided by our <strong>2025–2029 Medium Term Development Plan</strong>, we are committed to transforming Igbo-Eze North through:</p>
        <ul>
          <li><strong>Inclusive economic growth</strong></li>
          <li><strong>Improved healthcare and education</strong></li>
          <li><strong>Infrastructure and basic service delivery</strong></li>
          <li><strong>Transparent governance</strong></li>
          <li><strong>Environmental resilience and social justice</strong></li>
        </ul>
      </div>
    </div>
  );
};

export default DetailedBio;